
import utils from "@/utils/utils";
import { ElNotification } from 'element-plus';
import { defineComponent, provide} from "vue";
import { interfaceFunc } from "@/hooks/factoryFunc";
export default defineComponent({
   components: {
   },
   data() {
      return {};
   },
   setup(){

    const { getNewsDetail, getNewsList } = interfaceFunc(["getNewsDetail","getNewsList"]);
    /**
     * 获取今日消息提醒
     */
    const getNewsListToday = async () => {
      let result = await getNewsList({
        startDate:'',
        endDate:'',
        pageNum: 1,
        pageSize: 999,
        userCode: utils.$cookie.getCookie("hxUserCode"),
      });
      result.list.forEach((item:any)=>{
         if(!item.readStatus){
            setTimeout(()=>{
               let elNotifiObj = ElNotification({
                  title: '今日提醒',
                  message: item.content.replace('通知，',''),
                  type: 'success',
                  duration: 0,
                  onClose: ()=>{
                     readMessageFn(item)
                  }
               });
            },500);
         }
      });
    };
    const readMessageFn = (data:any)=>{
       getNewsDetail(data.id);
    }
    if(utils.$cookie.getCookie("hxUserCode") && utils.$cookie.getCookie("hxUserCode") !== '0'){
      getNewsListToday();
    }
   },
   mounted(){
      // window.addEventListener("beforeunload", e => {
      //    if (e) {
      //       e.returnValue = '关闭提示';
      //    }
      // });
   }
});
